module.exports = __webpack_public_path__ + "img/favicon_full.fab06e48.png";